module.exports = __webpack_public_path__ + "static/media/futaLogo.affb53d5.jpeg";